import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';

import CategoryService from "../../services/category.service";
import CategoryModal from "../modals/CategoryModal";
import { Pencil, ArrowUpCircle, ArrowDownCircle, PlusCircle } from 'react-bootstrap-icons';
import { Button } from 'react-bootstrap';

const AdminCategories = () => {
  const [categories, setCategories] = useState([1, 10]);
  const [modalShow, setModalShow] = useState(false);
  const [addModalShow, setAddModalShow] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [currentCategory, setCurrentCategory] = useState({});
  const [loading, setLoading] = useState(false);
  const { isSuperAdmin } = useSelector(state => state.auth);

  const updateCategoryName = async (category) => {
    console.log("Update Category Name:", category);
    await CategoryService.updateCategoryName(category);

    const allCategories = await CategoryService.getIgniteCategories();
    setCategories(allCategories);

    setModalShow(false);
    setCurrentCategory({});
  }

  const closeModal = (values) => {
    setModalShow(false);
  }
  const showModal = (category) => {
    setCurrentCategory(category);
    setModalShow(true);
  }

  const generateMenu = async () => {
    const allCategories = await CategoryService.generateMenu();
  }

  const addCategory = async () => {
    if (!newCategoryName.trim()) return;
    await CategoryService.addIgniteCategory(newCategoryName.trim());
    const allCategories = await CategoryService.getIgniteCategories();
    setCategories(allCategories);
    setNewCategoryName('');
    setAddModalShow(false);
  }

  const moveRow = async (direction, category) => {
    setLoading(true);
    console.log("Move:", direction, category.categoryName);
    var newCategoryList = [];
    var index = -1;
    for (var i = 0; i < categories.length; i++) {
      if (category.categoryName === categories[i].categoryName) {
        index = i;
      }
    }

    if (direction) { //move up
      if (index == 0) return;
      newCategoryList = [
        ...categories.slice(0, index - 1),
        categories[index],
        categories[index - 1],
        ...categories.slice(index + 1)
      ];
    } else { // move down
      if (index == categories.length - 1) return;
      newCategoryList = [
        ...categories.slice(0, index),
        categories[index + 1],
        categories[index],
        ...categories.slice(index + 2)
      ];
    }
    setCategories(newCategoryList);
    await CategoryService.updateCategoryOrder(newCategoryList);
    setLoading(false);
  }

  useEffect(() => {
    async function fetchData() {
      const allCategories = await CategoryService.getIgniteCategories();
      setCategories(allCategories);
      console.log("ALL CATS:", allCategories);
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (currentCategory && currentCategory.categoryName) {
      console.log("CURR CAT:", currentCategory);
      setModalShow(true);
    }
  }, [currentCategory]);

  return (
    <div className="container">
      <Button onClick={generateMenu}>Generate Menu</Button>
      {isSuperAdmin && (
        <Button variant="success" onClick={() => setAddModalShow(true)} style={{ marginLeft: 10 }}>
          <PlusCircle /> Add Category
        </Button>
      )}
      <h2>Categories</h2>
      <Table striped bordered hover style={{ marginTop: 20 }}>
        <thead>
          <tr>
            <th>Original Name</th>
            <th>Displayed Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {categories && categories.map(category => (
            <tr key={category.id}>
              <td>{category.categoryName}</td>
              <td>{category.overrideCategoryName}</td>
              <td><Button variant="link" size="sm" style={{ display: "inline-block" }} onClick={() => { showModal(category) }} disabled={loading}><Pencil /></Button>
                <Button variant="link" size="sm" onClick={() => { moveRow(true, category) }} disabled={loading}><ArrowUpCircle size={25} /></Button>
                <Button variant="link" size="sm" onClick={() => { moveRow(false, category) }} disabled={loading}><ArrowDownCircle size={25} /></Button>
              </td>
            </tr>
          ))
          }
        </tbody>
      </Table>
      {currentCategory && modalShow &&
        <CategoryModal show={modalShow} closeModal={closeModal} category={currentCategory} updateCategoryName={updateCategoryName} />
      }
      {addModalShow && (
        <Modal show={addModalShow} onHide={() => setAddModalShow(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Add New Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3" controlId="newCategoryName">
              <Form.Label>Category Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter category name"
                value={newCategoryName}
                onChange={(e) => setNewCategoryName(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setAddModalShow(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={addCategory} disabled={!newCategoryName.trim()}>
              Add Category
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};
export default AdminCategories;